import { UserModel } from "./authenticate-storage.model";

export class AuthenticateResponseModel {
    isValid: boolean | undefined | null = null;
    user: UserModel | undefined | null = null;
    responseMessage: string | undefined | null = null;
}

export class AuthenticateRequestModel {
    username: string;
    password: string ;
}